import { useEffect, useState } from "react";
import * as pdfjs from "pdfjs-dist";
import workerSrc from "pdfjs-dist/build/pdf.worker?url";
import Loader from "../Loader";
import { useLogger } from "../../hooks/useLogger";
import { getEsignDocumentUrl } from "../../utils/pdfUrl";

pdfjs.GlobalWorkerOptions.workerSrc = workerSrc;

const PDFTileView = ({ documents, setSelectedPdf }) => {
    const logEvent = useLogger();
    const [thumbnails, setThumbnails] = useState([]);
    const [selectedFileUrl, setSelectedFileUrl] = useState(null);
    const [loader, setLoader] = useState(false);

    useEffect(() => {
        setLoader(true)
        let isMounted = true;
    
        const loadThumbnails = async () => {
            const thumbData = await Promise.all(
                documents.map(async (pdf) => {
                try {
                    const fileUrl = getEsignDocumentUrl(pdf.file_url);
                    const loadingTask = pdfjs.getDocument(fileUrl);
                    const pdfDoc = await loadingTask.promise;
                    const page = await pdfDoc.getPage(1);
        
                    const viewport = page.getViewport({ scale: 1.0 });
                    const canvas = document.createElement("canvas");
                    const context = canvas.getContext("2d");
                    canvas.height = viewport.height;
                    canvas.width = viewport.width;
        
                    await page.render({ canvasContext: context, viewport }).promise;
                    
                    return {
                        name: pdf.document_name,
                        image: canvas.toDataURL(),
                        file_url: fileUrl,
                    };
                } catch (error) {
                    console.error("Error generating thumbnail:", error);
                    return null;
                }
                })
            );
        
            const filtered = thumbData.filter(Boolean);
        
            if (isMounted) {
                setThumbnails(filtered);
                if (filtered.length > 0) {
                    setSelectedPdf(filtered[0]);
                    setSelectedFileUrl(filtered[0].file_url);
                }
                setLoader(false)
            }
        };
    
        loadThumbnails();
    
        return () => {
            isMounted = false;
        };
    }, [documents, setSelectedPdf]);
  
    const handleSelect = (thumb) => {
        setSelectedFileUrl(thumb.file_url);
        setSelectedPdf(thumb);
    };

    return (<>
        <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
        {thumbnails.map((thumb, index) => {
            const isSelected = thumb.file_url === selectedFileUrl;
            return (
                <div
                key={index}
                style={{ width: 130, height: 164, cursor: "pointer", background: "#F3F3F3", borderRadius: "16px", padding: "7px", border: isSelected  ? "2px solid #185CB7" : "", boxSizing: "border-box",
                    position: "relative",
                    overflow: "hidden", }}
                onClick={() => {logEvent('Click', `Click on ${thumb?.file_url} template`, 'new-esign/Review-Send'); handleSelect(thumb)}}
                >
                    {isSelected && (<>
                        <div
                            style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            backgroundColor: "#1D1D1D24",
                            zIndex: 1,
                            borderRadius: 8,
                            }}
                        />
                        <img src={`${process.env.PUBLIC_URL}/images/checkmark.png`} id="checkmark" alt="checkmark Icon" style={{ position: "absolute", zIndex: 1, right: "3px", top: "4px" }} />
                    </>
                    )}
                    <img src={thumb.image} alt={thumb.name} width="100%" height= "150px" />
                </div>
            );
        })}
        </div>
        {loader && <Loader />}
        </>
    );
};

export default PDFTileView;
